import baustein from "baustein";
import template from "templates/modules/feed_pagination.jinja";
import traversal from "web/script/dom/traversal";
import history from "web/script/utils/history";

var DISABLED_MODIFIER = "feed-pagination--disabled";

baustein.register("feed-pagination", {
    template: template,

    defaultOptions: {
        disabled: false,
        useClientRouting: false,
    },

    init: function () {
        this.el.classList.toggle(DISABLED_MODIFIER, this.options.disabled);
    },

    setupEvents: function (add) {
        add("click", "a", this.onClick);
    },

    onClick: function (event) {
        if (this.options.useClientRouting) {
            event.preventDefault();
            const urlPath = traversal.closest(event.target, "a").href;
            history.pushState(new URL(urlPath, window.location.href));
        }
    },

    onOptionsChange: function () {
        this.el.classList.toggle(DISABLED_MODIFIER, this.options.disabled);
    },
});
